module.exports = __webpack_public_path__ + "media/images/animations/tire_widths/3-bdd43006cb3e2dd0642d2785a69d412e.png";